import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ServiceSharedData } from 'src/app/core/services/shared-data.service';
import { configureGoogleMapSearchAutocomplete } from 'src/app/core/utils/google-map-latlng-search.util';
declare let google: any;
declare let L;

@Component({
  selector: 'app-trip-map',
  templateUrl: './trip-map.component.html',
  styleUrls: ['./trip-map.component.scss']
})
export class TripMapComponent implements OnInit {

  modifyshow: boolean = true;
  dialogData1: any[] = [];
  tripsList: any[] = [];
  markers: any[] = [];
  latlongs = [];
  dialogData: any;
  // currentUser: any;
  roleName: any;
  zoneName: any;
  tripStatus: any;
  _mCurrentUser: any;
  liveData: any;
  tripListData: any;
  routeId: any;
  lat = 13.0196;
  lng = 77.5968;
  map: any;
  searchButtonFlag: boolean = true;
  modifyButtonFlag: boolean;
  isFixedRoute: boolean = false;
  fixedRouteStops: any[] = [];
  showHomePoints: boolean = false;
  homeMarkers: any[] = [];
  showGoogleMap = false;
  isOsm = false;
  private googleMapInitialized = false;
  private mapLoadAttempts = 0;
  private readonly maxMapLoadAttempts = 30;
  private searchBox: any = null;
  showGoogleSearch = false;
  private googleSearchControlAttached = false;

  constructor(
    private router: Router,
    private readonly apiService: ApiService,
    private serviceSharedData: ServiceSharedData,
    public serviceLocalStorage: ServiceLocalStorage,
    private notifyService: NotificationService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<TripMapComponent>,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.shortingBasedOnRouteOrder(data);
    this.dialogData1.push(data);
    this.dialogData = data;
    this.modifyButtonFlag = this.dialogData.params.tripEditFlag;
    this.modifyshow = !data.modifyshow;
    this.searchButtonFlag = !data.searchButtonFlag;
  }

  ngOnInit() {
    this.roleName = this.serviceLocalStorage.getRoleName();
    this.zoneName = this.data.data.zone?.name || 'NA';
    this.data.data.zone = this.data.data.zone || 'NA';
    this.tripsList.push(this.dialogData.data.tripId);
    this.modifyshow = !this.dialogData.params?.modifyshow;
    this.getTripDetails();
    this.getDeviceTripStatus();
    this.checkPreDefinedRoute();
  }

  onClickCancel(): void {
    this.dialogRef.close();
  }

  checkPreDefinedRoute() {
    const clientCode = localStorage.getItem('clientCode');
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getPreDefineRoute + clientCode,
      success => {
        const usePredefinedRoute = success.body?.usePredefinedRoute;
        const routeName = this.dialogData.data.routeName;
        this.isFixedRoute = usePredefinedRoute && routeName !== null;
        if (this.isFixedRoute) {
          this.fetchPredefinedRouteStops();
        } else {
          this.initMap();
        }
      },
      error => {
        console.log(error);
        this.isFixedRoute = false;
        this.initMap();
      }
    );
  }

  fetchPredefinedRouteStops() {
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getPreDefineRouteDetails + this.dialogData.data.routeName + '&siteId=' + this.dialogData.data.site.siteId,
      success => {
        if (success.body?.length) {
          const siteLat = this.dialogData.data.site.landmark.latitude;
          const siteLng = this.dialogData.data.site.landmark.longitude;
          this.fixedRouteStops = success.body.map((stop, index) => ({
            stopOrder: index + 1,
            landmarkId: stop.landmark.id,
            landmark: stop.landmark.landmark,
            area: stop.area?.area || 'NA',
            latitude: stop.landmark.latitude,
            longitude: stop.landmark.longitude
          }));
          this.fixedRouteStops.sort((a, b) => {
            const distA = Math.pow(a.latitude - siteLat, 2) + Math.pow(a.longitude - siteLng, 2);
            const distB = Math.pow(b.latitude - siteLat, 2) + Math.pow(b.longitude - siteLng, 2);
            return distB - distA;
          });
          this.fixedRouteStops.forEach((stop, i) => stop.stopOrder = i + 1);
        } else {
          this.isFixedRoute = false;
        }
        this.initMap();
      },
      error => {
        console.log(error);
        this.isFixedRoute = false;
        this.initMap();
      }
    );
  }

  initMap() {
    if (this.dialogData?.skipGoogleMap) {
      this.initMapByClientFlag();
      return;
    }
    const clientCode = localStorage.getItem('clientCode');
    const start = () => this.initMapByClientFlag();
    if (!clientCode) {
      start();
      return;
    }
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getMapType + clientCode,
      success => {
        if (success.status === 200) {
          this.serviceLocalStorage.setGoogleMapTypeEnabled(!!success.body?.isGoogleMapEnabled);
        }
        start();
      },
      () => start()
    );
  }

  /** Uses client master-config flag (same as add-edit-user / trip-modify). */
  private initMapByClientFlag(): void {
    this.showGoogleMap = this.dialogData?.skipGoogleMap
      ? false
      : this.serviceLocalStorage.isSetGoogleMapTypeEnabled();
    this.isOsm = !this.showGoogleMap;
    this.searchBox = null;
    this.showGoogleSearch = false;
    this.googleMapInitialized = false;
    this.mapLoadAttempts = 0;
    setTimeout(() => {
      if (this.isOsm) {
        this.loadOsmap();
        this.isFixedRoute ? this.showFixedRouteOnOSMap() : this.showTripOnOSMap();
        if (this.liveData) {
          this.plotVehicle();
        }
      } else {
        this.cd.detectChanges();
        this.loadgmap(() => {
          this.isFixedRoute ? this.showFixedRouteOnGMap() : this.showTripOnMap();
          if (this.liveData) {
            this.plotVehicle();
          }
        });
      }
    }, 0);
  }

  loadOsmap() {
    this.map = L.map("map", {
      fullscreenControl: true,
      dragging: true
    }).setView([this.dialogData.data.site.landmark.latitude, this.dialogData.data.site.landmark.longitude], 13);
    L.tileLayer(AppConstants.OSM_TILE, { attribution: AppConstants.OSM_CONTRIBUTORS }).addTo(this.map);
  }

  loadgmap(afterInit?: () => void) {
    if (!this.showGoogleMap || this.isOsm) {
      return;
    }
    if (this.googleMapInitialized) {
      afterInit?.();
      return;
    }
    const mapEl = document.getElementById('map');
    if (!mapEl) {
      this.scheduleGoogleMapLoadRetry(afterInit);
      return;
    }
    if (typeof google === 'undefined' || (!google.maps?.Map && !google.maps?.importLibrary)) {
      this.scheduleGoogleMapLoadRetry(afterInit);
      return;
    }
    this.initGoogleMapAsync(mapEl, afterInit);
  }

  private scheduleGoogleMapLoadRetry(afterInit?: () => void): void {
    if (++this.mapLoadAttempts >= this.maxMapLoadAttempts) {
      afterInit?.();
      return;
    }
    setTimeout(() => this.loadgmap(afterInit), 100);
  }

  private async initGoogleMapAsync(mapEl: HTMLElement, afterInit?: () => void): Promise<void> {
    if (this.googleMapInitialized) {
      afterInit?.();
      return;
    }
    try {
      const mapCenter = {
        lat: this.dialogData.data.site.landmark.latitude,
        lng: this.dialogData.data.site.landmark.longitude
      };
      let MapClass = google.maps?.Map;
      if (google.maps?.importLibrary) {
        const mapsLib = await google.maps.importLibrary('maps') as any;
        MapClass = mapsLib.Map;
      }
      if (!MapClass) {
        this.scheduleGoogleMapLoadRetry(afterInit);
        return;
      }
      this.map = new MapClass(mapEl, {
        center: mapCenter,
        zoom: 12,
        draggable: true,
        zoomControl: true,
        gestureHandling: 'greedy'
      });
      this.googleMapInitialized = true;
      this.googleSearchControlAttached = false;
      google.maps.event.addListenerOnce(this.map, 'idle', () => {
        google.maps.event.trigger(this.map, 'resize');
        this.map.setCenter(mapCenter);
        this.attachGoogleSearchControl('trip-map-google-search');
        afterInit?.();
      });
    } catch (error) {
      console.error('Google Map init failed', error);
      this.scheduleGoogleMapLoadRetry(afterInit);
    }
  }

  private attachGoogleSearchControl(elementId: string): void {
    if (!this.map?.controls || this.googleSearchControlAttached || !this.showGoogleMap) {
      return;
    }
    const searchEl = document.getElementById(elementId);
    if (!searchEl) {
      setTimeout(() => this.attachGoogleSearchControl(elementId), 50);
      return;
    }
    const position = google.maps.ControlPosition?.LEFT_TOP;
    this.map.controls[position].push(searchEl);
    this.googleSearchControlAttached = true;
  }

  openGoogleMapSearch(): void {
    if (!this.showGoogleMap || this.isOsm) {
      return;
    }
    this.showGoogleSearch = true;
    this.searchBox = null;
    setTimeout(() => this.initMapSearchBox(), 0);
  }

  closeGoogleMapSearch(): void {
    this.showGoogleSearch = false;
    this.searchBox = null;
  }

  private initMapSearchBox(): void {
    if (!this.showGoogleMap || this.isOsm || !this.showGoogleSearch || this.searchBox || !this.map) {
      return;
    }
    this.setupMapSearchBox();
  }

  private async setupMapSearchBox(): Promise<void> {
    if (!this.showGoogleMap || this.isOsm || !this.showGoogleSearch || this.searchBox || !this.map) {
      return;
    }

    let PlaceAutocompleteElementClass =
      (google.maps as any)?.places?.PlaceAutocompleteElement;
    if (google.maps?.importLibrary) {
      try {
        const placesLib = await google.maps.importLibrary('places') as any;
        PlaceAutocompleteElementClass = placesLib.PlaceAutocompleteElement;
      } catch (error) {
        console.error('Google Places library load failed', error);
      }
    }

    if (!PlaceAutocompleteElementClass) {
      if (this.showGoogleSearch) {
        setTimeout(() => this.setupMapSearchBox(), 100);
      }
      return;
    }

    const container = document.getElementById('autocomplete-container');
    if (!container) {
      if (this.showGoogleSearch) {
        setTimeout(() => this.setupMapSearchBox(), 100);
      }
      return;
    }

    container.innerHTML = '';
    const autocompleteElement = new PlaceAutocompleteElementClass({
      includedRegionCodes: ['IN'],
      placeholder: 'Search Address'
    });
    container.appendChild(autocompleteElement);
    this.searchBox = configureGoogleMapSearchAutocomplete(
      autocompleteElement,
      coords => this.applyGoogleSearchLatLng(coords)
    );

    autocompleteElement.addEventListener('gmp-select', async (event: any) => {
      const prediction = event.placePrediction;
      if (!prediction) {
        return;
      }
      const place = prediction.toPlace();
      await place.fetchFields({
        fields: ['displayName', 'formattedAddress', 'location', 'viewport']
      });
      if (!place.location) {
        return;
      }
      if (place.viewport) {
        this.map.fitBounds(place.viewport);
      } else {
        this.map.setCenter(place.location);
        this.map.setZoom(16);
      }
      this.closeGoogleMapSearch();
    });
  }

  private applyGoogleSearchLatLng(coords: { lat: number; lng: number }): void {
    if (!this.map || this.isOsm) {
      return;
    }
    const location = new google.maps.LatLng(coords.lat, coords.lng);
    this.map.setCenter(location);
    this.map.setZoom(16);
    this.closeGoogleMapSearch();
  }

  /** Keep Google employee pins at a fixed map size (SVGs otherwise render huge). */
  private getGoogleEmployeeIcon(iconUrl: string): any {
    return {
      url: iconUrl,
      scaledSize: new google.maps.Size(36, 42),
      anchor: new google.maps.Point(18, 42),
      labelOrigin: new google.maps.Point(18, -6)
    };
  }

  /**
   * Draws the shortest driving path using the same strategy as backend
   * GoogleMapRouteUtils.getShortestRouteDistanceAndTime:
   * Routes API computeRoutes + TRAFFIC_UNAWARE + alternatives → min distanceMeters.
   */
  private async drawShortestGoogleRoute(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[] = []
  ): Promise<void> {
    try {
      const drawn = await this.drawShortestRouteViaMapsJs(origin, destination, middlePoints)
        || await this.drawShortestRouteViaRestApi(origin, destination, middlePoints);
      if (drawn) {
        return;
      }
    } catch (error) {
      console.warn('Shortest Routes API path failed; falling back to Directions alternatives', error);
    }
    this.drawShortestRouteViaDirectionsService(origin, destination, middlePoints);
  }

  private async drawShortestRouteViaMapsJs(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[]
  ): Promise<boolean> {
    if (!google.maps?.importLibrary) {
      return false;
    }
    const routesLib = await google.maps.importLibrary('routes') as any;
    const RouteClass = routesLib?.Route;
    if (!RouteClass?.computeRoutes) {
      return false;
    }
    // Alternatives are only returned when there are no intermediate waypoints.
    const request: any = {
      origin,
      destination,
      travelMode: 'DRIVE',
      routingPreference: 'TRAFFIC_UNAWARE',
      computeAlternativeRoutes: middlePoints.length === 0,
      fields: ['path', 'distanceMeters', 'polyline']
    };
    if (middlePoints.length) {
      request.intermediates = middlePoints.map(point => ({ location: point }));
    }
    const { routes } = await RouteClass.computeRoutes(request);
    const shortest = this.pickShortestRouteByDistanceMeters(routes);
    if (!shortest) {
      return false;
    }
    let path = shortest.path;
    if (!path?.length && shortest.polyline?.encodedPolyline) {
      path = this.decodeGoogleEncodedPolyline(shortest.polyline.encodedPolyline);
    }
    if (!path?.length) {
      return false;
    }
    this.renderGoogleRoutePath(path);
    return true;
  }

  private async drawShortestRouteViaRestApi(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[]
  ): Promise<boolean> {
    const apiKey = this.getGoogleMapsApiKey();
    if (!apiKey) {
      return false;
    }
    const body: any = {
      origin: { location: { latLng: { latitude: origin.lat, longitude: origin.lng } } },
      destination: { location: { latLng: { latitude: destination.lat, longitude: destination.lng } } },
      travelMode: 'DRIVE',
      routingPreference: 'TRAFFIC_UNAWARE',
      computeAlternativeRoutes: middlePoints.length === 0,
      languageCode: 'en-US',
      units: 'METRIC'
    };
    if (middlePoints.length) {
      body.intermediates = middlePoints.map(point => ({
        location: { latLng: { latitude: point.lat, longitude: point.lng } }
      }));
    }
    const response = await fetch('https://routes.googleapis.com/directions/v2:computeRoutes', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Goog-Api-Key': apiKey,
        'X-Goog-FieldMask': 'routes.distanceMeters,routes.polyline.encodedPolyline'
      },
      body: JSON.stringify(body)
    });
    if (!response.ok) {
      console.warn('Routes REST API failed', response.status, await response.text());
      return false;
    }
    const payload = await response.json();
    const shortest = this.pickShortestRouteByDistanceMeters(payload?.routes);
    const encoded = shortest?.polyline?.encodedPolyline;
    if (!encoded) {
      return false;
    }
    this.renderGoogleRoutePath(this.decodeGoogleEncodedPolyline(encoded));
    return true;
  }

  private drawShortestRouteViaDirectionsService(
    origin: { lat: number; lng: number },
    destination: { lat: number; lng: number },
    middlePoints: { lat: number; lng: number }[]
  ): void {
    const directionsService = new google.maps.DirectionsService();
    const directionsDisplay = new google.maps.DirectionsRenderer({
      suppressMarkers: true,
      polylineOptions: { strokeColor: '#000', strokeWeight: 3, strokeOpacity: 0.7 }
    });
    directionsDisplay.setMap(this.map);
    directionsService.route({
      origin,
      destination,
      waypoints: middlePoints.map(point => ({ location: point, stopover: true })),
      optimizeWaypoints: false,
      avoidHighways: false,
      avoidTolls: false,
      provideRouteAlternatives: middlePoints.length === 0,
      travelMode: google.maps.DirectionsTravelMode.DRIVING
    }, (response, status) => {
      if (status !== google.maps.DirectionsStatus.OK || !response?.routes?.length) {
        return;
      }
      const shortestRoute = response.routes.reduce((shortest, route) => {
        const shortestDist = this.getDirectionsRouteDistanceMeters(shortest);
        const routeDist = this.getDirectionsRouteDistanceMeters(route);
        return routeDist < shortestDist ? route : shortest;
      }, response.routes[0]);
      response.routes = [shortestRoute];
      directionsDisplay.setDirections(response);
    });
  }

  private pickShortestRouteByDistanceMeters(routes: any[] | undefined): any | null {
    if (!routes?.length) {
      return null;
    }
    return routes.reduce((shortest, route) => {
      const shortestDist = shortest?.distanceMeters ?? Number.MAX_SAFE_INTEGER;
      const routeDist = route?.distanceMeters ?? Number.MAX_SAFE_INTEGER;
      return routeDist < shortestDist ? route : shortest;
    }, routes[0]);
  }

  private getDirectionsRouteDistanceMeters(route: any): number {
    return (route?.legs || []).reduce((sum, leg) => sum + (leg?.distance?.value || 0), 0);
  }

  private renderGoogleRoutePath(path: any[]): void {
    if (!path?.length || !this.map) {
      return;
    }
    new google.maps.Polyline({
      path,
      strokeColor: '#000',
      strokeWeight: 3,
      strokeOpacity: 0.7,
      map: this.map
    });
    const bounds = new google.maps.LatLngBounds();
    path.forEach(point => bounds.extend(point));
    this.map.fitBounds(bounds);
  }

  private getGoogleMapsApiKey(): string | null {
    const scripts = Array.from(document.getElementsByTagName('script'));
    const mapsScript = scripts.find(script => script.src?.includes('maps.googleapis.com/maps/api/js'));
    if (!mapsScript?.src) {
      return null;
    }
    try {
      return new URL(mapsScript.src).searchParams.get('key');
    } catch {
      return null;
    }
  }

  private decodeGoogleEncodedPolyline(encoded: string): { lat: number; lng: number }[] {
    let index = 0;
    let lat = 0;
    let lng = 0;
    const coordinates: { lat: number; lng: number }[] = [];
    while (index < encoded.length) {
      let shift = 0;
      let result = 0;
      let byte: number;
      do {
        byte = encoded.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);
      lat += (result & 1) ? ~(result >> 1) : (result >> 1);

      shift = 0;
      result = 0;
      do {
        byte = encoded.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);
      lng += (result & 1) ? ~(result >> 1) : (result >> 1);

      coordinates.push({ lat: lat / 1e5, lng: lng / 1e5 });
    }
    return coordinates;
  }

  showTripOnOSMap() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getdirectionresult + this.dialogData.data.tripId, success => {
      let wps = [];
      if (success.body.OSRM) {
        success.body.OSRM.waypoints.forEach((wp, i) => {
          this.latlongs.push([wp.location[1], wp.location[0]]);
          wps.push(L.latLng(wp.location[1], wp.location[0]));
        });
        let r = L.Routing.control({
          serviceUrl: AppConstants.OSM_ROUTING_URL,
          showAlternatives: false,
          lineOptions: {
            styles: [{
              color: "#000",
              weight: 3,
              opacity: 0.7
            }]
          },
          fitSelectedRoutes: true,
          waypointMode: "connect",
          addWaypoints: false,
          draggableWaypoints: false,
          autoRoute: true,
          reverseWaypoints: false,
          altLineOptions: {
            styles: [{
              color: "#ed6852",
              weight: 3
            }]
          },
          show: true,
          routeWhileDragging: false,
          createMarker: (i, wp, nWps) => {
            if (success.body.LOGTYPE === "IN") {
              if (i === this.dialogData.data.tripUsers.length) {
                let m = L.marker(wp.latLng, {
                  icon: L.icon({
                    iconUrl: "./assets/images/company.png",
                    iconSize: [40, 40]
                  })
                }).bindPopup(this.dialogData.data.site.landmark.landmark);
                return m;
              }
            } else {
              if (i === 0) {
                let m = L.marker(wp.latLng, {
                  icon: L.icon({
                    iconUrl: "./assets/images/company.png",
                    iconSize: [40, 40]
                  })
                }).bindPopup(this.dialogData.data.site.landmark.landmark);
                return m;
              }
            }
            if (success.body.LOGTYPE === "IN") {
              if (i < this.dialogData.data.tripUsers.length) {
                let m = L.marker(wp.latLng, {
                  icon: L.icon({
                    iconUrl: this.dialogData.data.tripUsers[i].tripUser.userInfoDetails.gender === "Female"
                      ? "./assets/images/livetracking/femaleloc.svg" : "./assets/images/livetracking/maleloc.svg", iconSize: [65, 70]
                  })
                }).bindPopup('<tr><td>UserName : </td<td>' + this.dialogData.data.tripUsers[i].tripUser.userInfoDetails.displayName +
                  '</td><br> <td>AL : </td><td>' + this.dialogData.data.tripUsers[i].landmark.area.area + ', '
                  + this.dialogData.data.tripUsers[i].landmark.landmark + '</td></tr>').bindTooltip(i + 1 + "", {
                    permanent: true,
                    direction: "left",
                    offset: L.point(-10, 0)
                  }).openTooltip();
                return m;
              }
            } else {
              if (i - 1 <= this.dialogData.data.tripUsers.length) {
                let m = L.marker(wp.latLng, {
                  icon: L.icon({
                    iconUrl:
                      this.dialogData.data.tripUsers[i - 1].tripUser.userInfoDetails.gender === "Female"
                        ? "./assets/images/livetracking/femaleloc.svg" : "./assets/images/livetracking/maleloc.svg",
                    iconSize: [65, 70]
                  })
                }).bindPopup('<tr><td>UserName : </td<td>' + this.dialogData.data.tripUsers[i - 1].tripUser.userInfoDetails.displayName +
                  '</td><br> <td>AL : </td><td>' + this.dialogData.data.tripUsers[i - 1].landmark.area.area + ', ' +
                  this.dialogData.data.tripUsers[i - 1].landmark.landmark + '</td></tr>').bindTooltip(i + "", {
                    permanent: true,
                    direction: "left",
                    offset: L.point(-10, 0)
                  })
                  .openTooltip();
                return m;
              }
            }
          }
        }).addTo(this.map);
        r.setWaypoints(wps);
        r.hide();
        this.plotHomePointsOSM();
      } else {
        this.notifyService.showError("OSRM data error.", null);
      }
    }, error => {
      console.log(error)
    });
  }

  getStopPopupContent(stop) {
    return `<span>AL: ${stop.area}, ${stop.landmark}</span>`;
  }

  addHomeMarkerOSM(user) {
    const homeLat = user?.tripUser?.userInfoDetails?.homeLatitude;
    const homeLng = user?.tripUser?.userInfoDetails?.homeLongitude;
    if (homeLat == null || homeLng == null || (homeLat === 0 && homeLng === 0)) {
      return;
    }
    const marker = L.marker([homeLat, homeLng], {
      icon: L.icon({ iconUrl: "./assets/images/home.png", iconSize: [28, 28] })
    }).bindPopup(this.getHomePopupContent(user))
      .bindTooltip(user.routedOrder + "", {
        permanent: true,
        direction: "left",
        offset: L.point(-10, 0)
      });
    this.homeMarkers.push(marker);
    if (this.showHomePoints) {
      marker.addTo(this.map);
    }
  }

  addHomeMarkerGoogle(user, infoWindow) {
    const homeLat = user?.tripUser?.userInfoDetails?.homeLatitude;
    const homeLng = user?.tripUser?.userInfoDetails?.homeLongitude;
    if (homeLat == null || homeLng == null || (homeLat === 0 && homeLng === 0)) {
      return;
    }
    const marker = new google.maps.Marker({
      position: { lat: homeLat, lng: homeLng },
      icon: { url: "./assets/images/home.png", scaledSize: new google.maps.Size(28, 28), labelOrigin: new google.maps.Point(14, -8) },
      map: this.showHomePoints ? this.map : null,
      title: `${user.tripUser.userInfoDetails.displayName} - Home`,
      label: { text: `P${user.routedOrder}`, color: "#000", fontWeight: "bold", fontSize: "12px" }
    });
    marker.addListener('click', () => {
      infoWindow.setContent(this.getHomePopupContent(user));
      infoWindow.open(this.map, marker);
    });
    this.homeMarkers.push(marker);
  }

  getHomePopupContent(user) {
    return '<tr><td>UserName : </td><td>' + user.tripUser.userInfoDetails.displayName +
      '</td><br> <td>Address : </td><td>' + (user.tripUser.userInfoDetails.address || 'NA') +
      '</td></tr>';
  }

  getEmployeePopupContent(user): string {
    const area = user?.landmark?.area?.area || 'NA';
    const landmark = user?.landmark?.landmark || 'NA';
    return '<div style="font-family: Poppins, sans-serif; font-size: 13px; line-height: 1.4;">'
      + '<div><strong>UserName :</strong> ' + (user?.tripUser?.userInfoDetails?.displayName || 'NA') + '</div>'
      + '<div><strong>AL :</strong> ' + area + ', ' + landmark + '</div>'
      + '</div>';
  }

  plotHomePointsOSM() {
    const tripUsers = this.dialogData.data.tripUsers || [];
    tripUsers.forEach(user => this.addHomeMarkerOSM(user));
  }

  onToggleHomePoints(enabled: boolean) {
    this.showHomePoints = enabled;
    if (this.isOsm) {
      this.homeMarkers.forEach(marker => {
        if (enabled) {
          marker.addTo(this.map);
        } else {
          this.map.removeLayer(marker);
        }
      });
    } else {
      this.homeMarkers.forEach(marker => marker.setMap(enabled ? this.map : null));
    }
  }

  showFixedRouteOnOSMap() {
    if (!this.fixedRouteStops.length) {
      this.notifyService.showError("No predefined route stops found.", null);
      return;
    }

    const siteLandmark = this.dialogData.data.site.landmark;
    const tripUsers = this.dialogData.data.tripUsers || [];

    L.marker([siteLandmark.latitude, siteLandmark.longitude], {
      icon: L.icon({ iconUrl: "./assets/images/company.png", iconSize: [40, 40] })
    }).addTo(this.map).bindPopup(siteLandmark.landmark);

    const wpMeta = [];
    const wps = [];

    tripUsers.forEach((user, i) => {
      wps.push(L.latLng(user.landmark.latitude, user.landmark.longitude));
      wpMeta.push({ type: 'user', data: user, index: i });
    });
    this.fixedRouteStops.forEach(stop => {
      wps.push(L.latLng(stop.latitude, stop.longitude));
      wpMeta.push({ type: 'stop', data: stop });
    });
    wps.push(L.latLng(siteLandmark.latitude, siteLandmark.longitude));
    wpMeta.push({ type: 'site' });

    const r = L.Routing.control({
      serviceUrl: AppConstants.OSM_ROUTING_URL,
      showAlternatives: false,
      lineOptions: { styles: [{ color: "#000", weight: 3, opacity: 0.7 }] },
      fitSelectedRoutes: true,
      waypointMode: "connect",
      addWaypoints: false,
      draggableWaypoints: false,
      autoRoute: true,
      reverseWaypoints: false,
      altLineOptions: { styles: [{ color: "#ed6852", weight: 3 }] },
      show: true,
      routeWhileDragging: false,
      createMarker: (i, wp, nWps) => {
        const meta = wpMeta[i];
        if (!meta) return null;

        if (meta.type === 'site') {
          return null;
        }

        if (meta.type === 'stop') {
          const stop = meta.data;
          return L.marker(wp.latLng, {
            icon: L.icon({ iconUrl: "./assets/images/livetracking/predefined-stop.svg", iconSize: [24, 40], iconAnchor: [12, 40] })
          }).bindPopup(this.getStopPopupContent(stop))
          // .bindTooltip(stop.stopOrder + "", {
          //   permanent: true,
          //   direction: "left",
          //   offset: L.point(-10, 0)
          // }).openTooltip();
        }

        if (meta.type === 'user') {
          const user = meta.data;
          const iconUrl = user.tripUser.userInfoDetails.gender === "Female"
            ? "./assets/images/livetracking/femaleloc.svg"
            : "./assets/images/livetracking/maleloc.svg";
          return L.marker(wp.latLng, {
            icon: L.icon({ iconUrl, iconSize: [65, 70] })
          }).bindPopup('<tr><td>UserName : </td><td>' + user.tripUser.userInfoDetails.displayName +
            '</td><br> <td>AL : </td><td>' + user.landmark.area.area + ', ' +
            user.landmark.landmark + '</td></tr>')
            .bindTooltip((meta.index + 1) + "", {
              permanent: true,
              direction: "left",
              offset: L.point(-10, 0)
            }).openTooltip();
        }
      }
    }).addTo(this.map);

    r.setWaypoints(wps);
    r.hide();
    this.plotHomePointsOSM();
  }

  showFixedRouteOnGMap() {
    if (!this.fixedRouteStops.length) {
      this.notifyService.showError("No predefined route stops found.", null);
      return;
    }

    const siteCoords = this.dialogData.data.site.landmark;
    const siteLatlng = { lat: siteCoords.latitude, lng: siteCoords.longitude };
    const isInTrip = this.dialogData.data.shift.logType === "IN";
    const tripUsers = this.dialogData.data.tripUsers || [];

    new google.maps.Marker({
      position: new google.maps.LatLng(siteLatlng.lat, siteLatlng.lng),
      icon: { url: "./assets/images/company.png", scaledSize: new google.maps.Size(40, 40) },
      map: this.map,
      title: this.dialogData.data.site.siteName
    });

    const infoWindow = new google.maps.InfoWindow();

    this.fixedRouteStops.forEach(stop => {
      const marker = new google.maps.Marker({
        position: { lat: stop.latitude, lng: stop.longitude },
        icon: { url: "./assets/images/livetracking/predefined-stop.svg", scaledSize: new google.maps.Size(24, 40), labelOrigin: new google.maps.Point(12, -8) },
        map: this.map,
        title: `Stop ${stop.stopOrder}: ${stop.landmark}`,
        label: { text: `S${stop.stopOrder}`, color: "#000", fontWeight: "bold", fontSize: "12px" }
      });
      marker.addListener('click', () => {
        infoWindow.setContent(this.getStopPopupContent(stop));
        infoWindow.open(this.map, marker);
      });
    });

    tripUsers.forEach((user, i) => {
      const iconUrl = user.tripUser.userInfoDetails.gender === "Female"
        ? "./assets/images/livetracking/femaleloc.svg"
        : "./assets/images/livetracking/maleloc.svg";
      const marker = new google.maps.Marker({
        position: { lat: user.landmark.latitude, lng: user.landmark.longitude },
        icon: this.getGoogleEmployeeIcon(iconUrl),
        map: this.map,
        title: `${user.tripUser.userInfoDetails.displayName} - ${user.routedOrder}`,
        label: { text: `${user.routedOrder}`, color: "#000", fontWeight: "bold", fontSize: "12px" }
      });
      marker.addListener('click', () => {
        infoWindow.setContent(this.getEmployeePopupContent(user));
        infoWindow.open(this.map, marker);
      });
      this.addHomeMarkerGoogle(user, infoWindow);
    });

    const allWaypts = [];
    tripUsers.forEach(user => {
      allWaypts.push({ location: { lat: user.landmark.latitude, lng: user.landmark.longitude }, stopover: true });
    });
    this.fixedRouteStops.forEach(stop => {
      allWaypts.push({ location: { lat: stop.latitude, lng: stop.longitude }, stopover: true });
    });


    const firstWp = allWaypts[0];
    const lastWp = allWaypts[allWaypts.length - 1];
    const startPoint = isInTrip ? firstWp.location : siteLatlng;
    const endPoint = isInTrip ? siteLatlng : lastWp.location;
    const middleWaypts = (isInTrip ? allWaypts.slice(1) : allWaypts.slice(0, -1))
      .map(wp => wp.location);

    this.drawShortestGoogleRoute(startPoint, endPoint, middleWaypts);
  }

  getDeviceTripStatus() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getDeviceTripStatus + '?tripId=' + this.data.data.tripId, success => {
      if (success != null) {
        this.tripStatus = success.body.deviceTripStatus;
      } else {
        this.tripStatus = '';
      }
    }, error => {
      console.log(error)
    });
  }

  GetSortOrder(prop) {
    // return function (a, b) {
    //   if (a[prop] > b[prop]) {
    //     return 1;
    //   } else if (a[prop] < b[prop]) {
    //     return -1;
    //   }
    //   return 0;
    // };
    return (a, b) => a[prop] > b[prop] ? 1 : a[prop] < b[prop] ? -1 : 0;
  }

  // showTripOnMap() {
  //   let sitecordinates = new google.maps.LatLng(
  //     this.dialogData.data.site.landmark.latitude,
  //     this.dialogData.data.site.landmark.longitude
  //   );
  //   let path = "./assets/images/company.png";
  //   var marker = new google.maps.Marker({
  //     position: sitecordinates,
  //     icon: {
  //       url: path,
  //       scaledSize: new google.maps.Size(40, 40)
  //     },
  //     map: this.map,
  //     title: this.dialogData.data.site.siteName
  //   });
  //   let waypts = [];
  //   this.dialogData.data.tripUsers.forEach(user => {
  //     let icon = "./assets/images/livetracking/maleloc.svg";
  //     if (user.tripUser.userInfoDetails.gender == "Female") {
  //       icon = "./assets/images/livetracking/femaleloc.svg";
  //     }
  //     var marker = new google.maps.Marker({
  //       position: { lat: user.landmark.latitude, lng: user.landmark.longitude },
  //       icon: { url: icon, labelOrigin: new google.maps.Point(18, -8) },
  //       draggable: false,
  //       map: this.map,
  //       title: user.tripUser.userInfoDetails.displayName + " - " + user.routedOrder,
  //       label: {
  //         text: "P" + user.routedOrder,
  //         color: "#000",
  //         fontWeight: "bold",
  //         fontSize: "12px"
  //       }
  //     });
  //     waypts.push({
  //       location: { lat: user.landmark.latitude, lng: user.landmark.longitude },
  //       stopover: true
  //     });
  //   });
  //   let startnodelatlng = {
  //     lat: this.dialogData.data.site.landmark.latitude,
  //     lng: this.dialogData.data.site.landmark.longitude
  //   };
  //   let endnodelatlng = {
  //     lat: this.dialogData.data.site.landmark.latitude,
  //     lng: this.dialogData.data.site.landmark.longitude
  //   };
  //   if (this.dialogData.data.shift.logType == "IN") {
  //     startnodelatlng = {
  //       lat: this.dialogData.data.tripUsers[0].landmark.latitude,
  //       lng: this.dialogData.data.tripUsers[0].landmark.longitude
  //     };
  //   } else {
  //     endnodelatlng = {
  //       lat: this.dialogData.data.tripUsers[this.dialogData.data.tripUsers.length - 1].landmark.latitude,
  //       lng: this.dialogData.data.tripUsers[this.dialogData.data.tripUsers.length - 1].landmark.longitude
  //     };
  //   }
  //   let request = {
  //     origin: startnodelatlng,
  //     destination: endnodelatlng,
  //     waypoints: waypts,
  //     optimizeWaypoints: false,
  //     avoidHighways: false,
  //     avoidTolls: true,
  //     travelMode: google.maps.DirectionsTravelMode.DRIVING
  //   };
  //   let directionsService = new google.maps.DirectionsService();
  //   let directionsDisplay = new google.maps.DirectionsRenderer({
  //     suppressMarkers: true
  //   });
  //   directionsDisplay.setMap(this.map);
  //   directionsService.route(request, (response, status) => {
  //     if (status == google.maps.DirectionsStatus.OK) {
  //       directionsDisplay.setDirections(response);
  //     }
  //   });
  // }

  showTripOnMap() {
    const siteCoords = this.dialogData.data.site.landmark;
    const siteLatlng = { lat: siteCoords.latitude, lng: siteCoords.longitude };
    new google.maps.Marker({
      position: new google.maps.LatLng(siteLatlng.lat, siteLatlng.lng),
      icon: { url: "./assets/images/company.png", scaledSize: new google.maps.Size(40, 40) },
      map: this.map,
      title: this.dialogData.data.site.siteName
    });
    const infoWindow = new google.maps.InfoWindow();
    const waypts = this.dialogData.data.tripUsers.map(user => {
      const iconUrl = user.tripUser.userInfoDetails.gender === "Female"
        ? "./assets/images/livetracking/femaleloc.svg"
        : "./assets/images/livetracking/maleloc.svg";
      const marker = new google.maps.Marker({
        position: { lat: user.landmark.latitude, lng: user.landmark.longitude },
        icon: this.getGoogleEmployeeIcon(iconUrl),
        map: this.map,
        title: `${user.tripUser.userInfoDetails.displayName} - ${user.routedOrder}`,
        label: { text: `${user.routedOrder}`, color: "#000", fontWeight: "bold", fontSize: "12px" }
      });
      marker.addListener('click', () => {
        infoWindow.setContent(this.getEmployeePopupContent(user));
        infoWindow.open(this.map, marker);
      });
      this.addHomeMarkerGoogle(user, infoWindow);
      return { lat: user.landmark.latitude, lng: user.landmark.longitude };
    });
    const isInTrip = this.dialogData.data.shift.logType === "IN";
    const firstUser = this.dialogData.data.tripUsers[0];
    const lastUser = this.dialogData.data.tripUsers[this.dialogData.data.tripUsers.length - 1];
    const startPoint = isInTrip
      ? { lat: firstUser.landmark.latitude, lng: firstUser.landmark.longitude }
      : siteLatlng;

    const endPoint = isInTrip
      ? siteLatlng
      : { lat: lastUser.landmark.latitude, lng: lastUser.landmark.longitude };
    // Exclude origin/destination from intermediates — duplicating them skews routing.
    const middleWaypts = isInTrip ? waypts.slice(1) : waypts.slice(0, -1);
    this.drawShortestGoogleRoute(startPoint, endPoint, middleWaypts);
  }

  modify() {
    // if (this.roleName == 'Admin' || this.roleName == 'Super Admin' || this.roleName == 'Site Admin') {
    //   this.dialogRef.close();
    //   this.serviceSharedData.setData("trips", [this.dialogData.data.tripId]);
    //   this.router.navigate(["/myatom/routing/tripmodify", this.dialogData.params.siteId, this.dialogData.params.shiftId, this.dialogData.params.date]);
    // } else {
    //   return this.notifyService.showWarning("You don't have permission", null);
    // }
    const allowedRoles = ['Admin', 'Super Admin', 'Site Admin'];
    if (!allowedRoles.includes(this.roleName)) {
      return this.notifyService.showWarning("You don't have permission", null);
    }
    this.dialogRef.close();
    this.serviceSharedData.setData("trips", [this.dialogData.data.tripId]);
    this.router.navigate(["/myatom/routing/tripmodify", this.dialogData.params.siteId, this.dialogData.params.shiftId, this.dialogData.params.date, false]);
  }

  stopTrip() {
    // if (this.roleName == 'Admin' || this.roleName == 'Super Admin' || this.roleName == 'Site Admin' || this.roleName == 'Vendor') {
    //   if (this.tripStatus == 'running') {
    //     this.apiService.doPostRequestWithResponse(ApiConstants.accidentalStop + '?tripId=' + this.data.data.tripId, '', success => {
    //       if (success != null) {
    //         this.notifyService.showSuccess(success.body.message, null);
    //       } else {
    //         this.notifyService.showError("Error in Updating", null);
    //       }
    //     },
    //       error => {
    //         console.log(error)
    //       });
    //   } else {
    //     this.notifyService.showInfo("Trip is not running", null);
    //   }
    // } else {
    //   return this.notifyService.showWarning("You don't have permission", null);
    // }
    const allowedRoles = ['Admin', 'Super Admin', 'Site Admin', 'Vendor'];
    if (!allowedRoles.includes(this.roleName)) {
      return this.notifyService.showWarning("You don't have permission", null);
    }
    if (this.tripStatus !== 'running') {
      return this.notifyService.showInfo("Trip is not running", null);
    }

    this.apiService.doPostRequestWithResponse(`${ApiConstants.accidentalStop}?tripId=${this.data.data.tripId}`, '', success => {
      const message = success?.body?.message ? success.body.message : "Error in Updating";
      const notifyMethod = success ? 'showSuccess' : 'showError';
      this.notifyService[notifyMethod](message, null);
    }, error => console.log(error));
  }

  getTripDetails() {
    const token = this.serviceLocalStorage.getAuthToken();
    this._mCurrentUser = this.serviceLocalStorage.getUserObject();
    let body = {
      tripIdList: this.tripsList,
      clientCode: this._mCurrentUser.clientCode,
      token: token
    };
    let liveTrak = "https://uat.myatom.app/livetrack/api/vehicle/";
    this.apiService.doPostRequestWithResponseForLiveTrack(liveTrak + ApiConstants.fetchgeoposition, body, success => {
      this.liveData = success.body;
      if (this.map) {
        this.plotVehicle();
        this.setOSMLiveLocation();
      }
    }, error => {
      console.log(error)
    });
  }

  setOSMLiveLocation() {
    if (this.showGoogleMap) {
      this.setGoogleLiveLocation();
      return;
    }
    if (this.liveData.length > 0) {
      this.liveData.forEach(vehicle => {
        this.markers.forEach(m => {
          if (m.customData.tripId === vehicle.tripId) {
            if (vehicle.status == 'DANGER') {
              m._icon.src = "./assets/images/livetracking/vehicle/FF503F.png"
            } else {
              m._icon.src = "./assets/images/livetracking/vehicle/" + vehicle.vehicleColorCode.replace(/#/g, "") + ".png#"
            }
            const elevationAngle = vehicle.elevation ? parseInt(vehicle.elevation) : 0;
            var newLatLng = new L.LatLng(vehicle.latitude, vehicle.longitude);
            m.setRotationAngle(elevationAngle);
            m.slideTo(newLatLng, {
              duration: 1000,
              keepAtCenter: false
            });
          }
        });
      });
    } else {
      if (this.markers.length > 0) {
        this.markers.forEach(m => {
          this.map.removeLayer(m);
        });
      }
    }
  }

  private setGoogleLiveLocation(): void {
    if (!this.map || !this.liveData) {
      return;
    }
    if (this.liveData.length > 0) {
      this.liveData.forEach(vehicle => {
        this.markers.forEach(m => {
          if (m.customData?.tripId === vehicle.tripId) {
            const iconUrl = vehicle.status === 'DANGER'
              ? "./assets/images/livetracking/vehicle/FF503F.png"
              : "./assets/images/livetracking/vehicle/" + vehicle.vehicleColorCode.replace(/#/g, "") + ".png#";
            m.setIcon({
              url: iconUrl,
              scaledSize: new google.maps.Size(45, 40),
              anchor: new google.maps.Point(15, 20)
            });
            m.setPosition({ lat: vehicle.latitude, lng: vehicle.longitude });
          }
        });
      });
    } else if (this.markers.length > 0) {
      this.markers.forEach(m => m.setMap(null));
      this.markers = [];
    }
  }

  plotVehicle() {
    if (!this.map) {
      return;
    }
    if (this.showGoogleMap) {
      this.markers.forEach(marker => marker.setMap(null));
    } else {
      this.markers.forEach(marker => {
        if (this.map?.hasLayer?.(marker)) {
          this.map.removeLayer(marker);
        }
      });
    }
    this.markers = [];
    if (this.liveData && this.liveData.length > 0) {
      this.liveData.forEach(vehicle => {
        this.showSingleRunningTrip(vehicle);
      });
    }
  }

  showSingleRunningTrip(vehicle) {
    // this.apiService.doPostRequestWithResponse(ApiConstants.showSingleRunningTrip + vehicle.tripId, '', success => {
    //   if (success.status == 200) {
    //     this.tripListData = success.body;
    //     if (this.tripListData[0] != null) {
    //       let tripcodes = success.body[0];
    //       let tripcode = success.body[0].tripDetails.tripCode;
    //       let tripCodeLength = tripcode.length;
    //       this.routeId = tripcode.slice(tripCodeLength - 3, tripCodeLength)
    //       if (vehicle.vehicleStatus !== "stopped") {
    //         this.addOSMarker(vehicle);
    //       }
    //     }
    //   }
    // },
    //   error => {
    //   }
    // );
    this.apiService.doPostRequestWithResponse(ApiConstants.showSingleRunningTrip + vehicle.tripId, '', success => {
      if (success.status === 200 && success.body?.[0]) {
        this.tripListData = success.body;
        const tripCode = success.body[0].tripDetails.tripCode;
        this.routeId = tripCode.slice(-3);
        if (vehicle.vehicleStatus !== "stopped") {
          this.addOSMarker(vehicle);
        }
      }
    }, () => { });
  }

  addOSMarker(vehicle) {
    if (!this.map) {
      return;
    }
    if (this.showGoogleMap) {
      this.addGoogleVehicleMarker(vehicle);
      return;
    }
    this.map.panTo(new L.LatLng(vehicle.latitude, vehicle.longitude));
    let carMarker = new L.Icon({
      iconUrl: "./assets/images/livetracking/vehicle/" + vehicle.vehicleColorCode.replace(/#/g, "") + ".png#",
      iconSize: [45, 40],
      iconAnchor: [15, 20]
    });
    let marker = new L.marker([vehicle.latitude, vehicle.longitude], {
      icon: carMarker
    }).addTo(this.map).bindPopup($('<b style="cursor:pointer">' + vehicle.vehicleNo + " " + this.routeId + "</b>").click(() => { })[0]);
    marker.customData = vehicle;
    this.markers.push(marker);
  }

  private addGoogleVehicleMarker(vehicle: any): void {
    const iconUrl = "./assets/images/livetracking/vehicle/" + vehicle.vehicleColorCode.replace(/#/g, "") + ".png#";
    const marker = new google.maps.Marker({
      position: { lat: vehicle.latitude, lng: vehicle.longitude },
      icon: {
        url: iconUrl,
        scaledSize: new google.maps.Size(45, 40),
        anchor: new google.maps.Point(15, 20)
      },
      map: this.map,
      title: `${vehicle.vehicleNo} ${this.routeId || ''}`.trim()
    });
    marker.customData = vehicle;
    this.map.panTo({ lat: vehicle.latitude, lng: vehicle.longitude });
    this.markers.push(marker);
  }

  shortingBasedOnRouteOrder(data) {
    return data['data']['tripUsers'].sort((a, b) => a.routedOrder - b.routedOrder);
  }

  performTripAction(
    action: string
  ): void {

    const allowedRoles = ['Admin', 'Super Admin', 'Site Admin', 'Vendor'];

    if (!allowedRoles.includes(this.roleName)) {
      this.notifyService.showWarning("You don't have permission", null);
      return;
    }

    this.apiService.doPostRequestWithResponse(
      `${ApiConstants.tripAction}${this.data.data.tripId}&action=${action}`,
      '',
      success => {
        if (success.status === 200) {
          const message = success?.body?.message ?? 'Error in updating';
          this.notifyService[message === 'Updated successfully' ? 'showSuccess' : 'showWarning'](message, null);
        }
      },
      error => {
        console.error(error);
        this.notifyService.showError('Error in updating', null);
      }
    );
  }
}
